export default {
    imageAIFormRules: {
        enterDescription: 'Por favor, escriba la descripción',
        invalidDescription: 'Por favor, escriba una descripción válida',
        enterNumberOfVariations: 'Por favor, selecciona el número de variantes',
        invalidNumberOfVariations: 'Puedes generar un mínimo de 1 y un máximo de 4 variaciones',
        enterStyle: 'Por favor, seleccione al menos un estilo',
    },
};
